import { Routes, Route, Link, useLocation } from "react-router-dom";
import Announcements from "./Announcements";
import SectionActivities from "./SectionActivities";
import SectionMembers from "./SectionMembers";
// import SectionDues from "./SectionDues";
import Events from "./Events";
// import PostsHeld from "./PostsHeld";
import ProfileSetup from "./ProfileSetup";
import CreateMember from "./CreateMember";
import Home from "./Home";
import Members from "./Members";
import club_logo from '../images/club_logo_apapa.png'
import { useContext } from "react";
import { UserContext } from "../context/UserContext";
import { MenuContext } from '../context/MenuContext';
import { AiOutlineClose } from "react-icons/ai";

export default function Dashboard() {
  const location = useLocation();
  const {userProfile, logOutFunction} = useContext(UserContext);
  const { menuOpen, setMenuOpen } = useContext(MenuContext)

  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      <aside className={`transition-transform duration-500 fixed lg:relative top-0 bottom-0 z-[50] lg:z-[0] w-64 bg-gray-800 text-white p-6 space-y-4 ${menuOpen ? 'flex' : 'hidden lg:flex'} flex-col justify-start`}>
        <div className='flex flex-col justify-start items-center gap-y-2 w-full mt-[10px] mb-[30px]'>
            <div
                onClick={() => setMenuOpen(false)}
                className="block lg:hidden btn btn-ghost btn-circle mb-4 self-end fixed"
            >
                <AiOutlineClose className="h-7 w-7 text-dark" />
            </div>
            <img src={club_logo} className="h-[80px] rounded-full" alt="logo" />
            <h2 className="text-md font-bold">Membership Portal</h2>
        </div>
        <nav className="flex flex-col space-y-2 gap-y-1">
          <Link to="/dashboard/home" className={`py-2 px-3 hover:bg-gray-600 hover:font-semibold rounded-[7px] ${(location.pathname == "/dashboard/home") && 'bg-gray-700'}`} >Home</Link>
          <Link to="/dashboard/members" className={`py-2 px-3 hover:bg-gray-700 hover:font-semibold rounded-[7px] ${(location.pathname.startsWith("/dashboard/members")) && 'bg-gray-700'}`}>Club Members</Link>
          <Link to="/dashboard/announcements" className={`py-2 px-3 hover:bg-gray-600 hover:font-semibold rounded-[7px] ${(location.pathname == "/dashboard/announcements") && 'bg-gray-700'}`} >Announcements</Link>
          <Link to="/dashboard/sections" className={`py-2 px-3 hover:bg-gray-700 hover:font-semibold rounded-[7px] ${(location.pathname.startsWith("/dashboard/sections")) && 'bg-gray-700'}`}>Club Sections</Link>
          {/* <Link to="/dashboard/events" className="py-2 px-3 hover:bg-gray-700 hover:font-semibold rounded-[7px]">Events</Link>
          <Link to="/dashboard/posts-held" className="py-2 px-3 hover:bg-gray-700 hover:font-semibold rounded-[7px]">Posts Held</Link> */}
          {/* <Link to="/dashboard/edit-profile" className={`py-2 px-3 hover:bg-gray-700 hover:font-semibold rounded-[7px] ${(location.pathname == "/dashboard/edit-profile") && 'bg-gray-700'}`}>Edit Profile</Link> */}
          <div onClick={() => window.open('https://theapapaclub.org/Rule Book V2025.pdf', '_blank')} className={`py-2 px-3 hover:font-semibold cursor-pointer hover:font-semibold rounded-[7px]`}>
            Get Rule Book
          </div>
          <div onClick={() => logOutFunction()} className={`py-2 px-3 hover:opacity-[0.8] text-[#ff0000] cursor-pointer hover:font-semibold rounded-[7px]`}>
            Log Out
          </div>
        </nav>
      </aside>

      {/* Main content */}
      <main className="flex-1 p-0 bg-gray-50">
        <Routes>
          <Route path="home" element={<Home />} />
          <Route path="announcements" element={<Announcements />} />
          <Route path="sections" element={<SectionActivities />} />
          <Route path="members" element={<Members />} />
          {/* <Route path="dues" element={<SectionDues />} /> */}
          <Route path="events" element={<Events />} />
          <Route path="members/edit-profile" element={<ProfileSetup />} />
          <Route path="sections/members/:section_id" element={<SectionMembers />} />
          <Route path="members/create" element={<CreateMember />} />
        </Routes>
      </main>
    </div>
  );
}
